/**
 * @file 将 atom 文件转成 vue 文件
 * @author cxtom(cxtom2008@gmail.com)
 */

/* eslint-disable fecs-no-require */

const {configCompiler, compileStyles} = require('atom-web-compiler');
const path = require('path');
const hashSum = require('hash-sum');
const loaderUtils = require('loader-utils');
const qs = require('querystring');
const parse = require('./parse');

module.exports = function (content) {

    const loaderContext = this;

    const options = loaderUtils.getOptions(loaderContext) || {};
    const compilerOptions = options.compiler || {};
    const isServer = loaderContext.target === 'node';

    let scriptLoaders = Array.isArray(options.scriptLoaders) ? options.scriptLoaders.join('!') : '';
    if (scriptLoaders.length) {
        scriptLoaders += '!';
    }

    var babelLoaderOptionsString = options.babelLoaderOptions ? ('?' + JSON.stringify(options.babelLoaderOptions)) : '';

    const {
        resourcePath
    } = loaderContext;

    const blocks = parse({
        source: content,
        filename: path.basename(resourcePath)
    });

    let config = null;
    if (blocks.config && blocks.config.code) {
        config = configCompiler.compile(
            isServer ? blocks.config.code.replace(/!!lazy!/g, '') : blocks.config.code,
            Object.assign({
                compileJSComponent(current) {
                    return `require("${current}").default || require("${current}")`;
                }
            }, compilerOptions)
        );
    }

    let styles = null;
    let cssModules = null;
    if (blocks.styles && blocks.styles.length > 0) {
        const scopeId = 'data-a-' + hashSum(content);
        const styleCompilerOptions = compilerOptions.styleCompilerOptions || {};
        let resolveAssertUrl;
        if (styleCompilerOptions && styleCompilerOptions.resolveAssertUrl) {
            resolveAssertUrl = url => styleCompilerOptions
                .resolveAssertUrl
                .call(loaderContext, url, resourcePath);
        }
        styles = compileStyles({
            context: this.rootContext,
            filename: path.relative(this.rootContext, this.resourcePath),
            styles: blocks.styles,
            scopeId,
            ...styleCompilerOptions,
            resolveAssertUrl
        });
        cssModules = styles.cssModules;
    }

    const stringifyRequest = r => loaderUtils.stringifyRequest(this, r);

    const needScript = isServer
        ? (
            (blocks.php && blocks.php.code && blocks.php.code.trim())
            || (blocks.script && blocks.script.lang === 'ts')
        )
        : true;

    // script
    let scriptImport = 'var obj = {}';
    if (needScript && blocks.script && blocks.script.code && blocks.script.code.trim()) {
        const src = blocks.script.src || resourcePath;
        const scriptSelector = require.resolve('./scriptSelector.js');
        const sourcePath = `${blocks.script.src ? '' : scriptSelector + '!'}${src}`;
        let scriptRequest = stringifyRequest(`!!babel-loader${babelLoaderOptionsString}!${scriptLoaders}${sourcePath}`);
        if (blocks.script.lang === 'ts') {
            const tsLoaderOptions = {
                transpileOnly: true,
                appendTsSuffixTo: ['\\.atom$']
            };
            scriptLoaders += isServer ? `${require.resolve('./replace-dynamic-import')}!` : '';
            scriptRequest = stringifyRequest(`!!babel-loader${babelLoaderOptionsString}!ts-loader?${JSON.stringify(tsLoaderOptions)}!${scriptLoaders}${sourcePath}`); // eslint-disable-line
        }
        scriptImport = `
import script from ${scriptRequest};
var obj = typeof script === 'function' ? script.options : script;
        `;
    }

    const templateLoader = require.resolve('./templateParser');
    const templateQuery = {
        scopeId: styles && styles.hasScoped ? styles.scopeId : undefined,
        cssModules: cssModules ? JSON.stringify(cssModules) : undefined,
        strip: compilerOptions.strip
    };

    // eslint-disable-next-line
    const templateRequest = stringifyRequest(`!!babel-loader${babelLoaderOptionsString}!${templateLoader}!${this.resourcePath}?${qs.stringify(templateQuery)}`);

    let script = `
    import {render, staticRenderFns} from ${templateRequest};
    ${scriptImport}
    obj.render = obj.render || render;
    obj.staticRenderFns = staticRenderFns;
    obj._compiled = true;
    `;

    script += config
    ? `
    ${config.parts.props ? ('obj.props = ' + config.parts.props.code.js + ';') : ''}
    ${config.parts.components ? ('obj.components = ' + config.parts.components.code.js + ';') : ''}
    ${config.abstract ? 'obj.abstract = true;' : ''}
    ${config.name ? `obj.name = ${JSON.stringify(config.name)};` : ''}
    ${config.functional ? 'obj.functional = true;' : ''}
    ${config.parts.data ? `obj.data = function () {return ${config.parts.data.code.js};};` : ''}
    ${config.parts.computed && config.parts.computed.keys.length > 0
        ? `var computed = obj.computed || {};${config.parts.computed.code.js};obj.computed = computed;`
        : ''
    }
`
    : '';

    script += `
    var hook = function () {
        var self = this;
        this.$super = {
            render: function () {
                return render.apply(self, Array.prototype.slice.apply(arguments));
            }
        };
        ${cssModules ? Object.keys(cssModules).map(function (key) {
            return `this[${JSON.stringify(key)}] = ${JSON.stringify(cssModules[key])}`;
        }).join(';\n') : ''}
    };
    obj.created = obj.created
        ? [].concat(obj.created, hook)
        : [hook]
    ${styles && styles.hasScoped ? `obj._scopeId = '${styles.scopeId}';` : ''}
    export default obj;
    `;

    let result = `
${styles ? `<style>${styles.code}</style>` : ''}
<script>${script.trim()};</script>`;

    return result;
};
